import { Filter, FilteredFields, HandleChange } from '@/typings/filter/types';

export type RangeFilter = FilteredFields & { value: number[] };

export type Props = {
  field: Filter;
  value: number[];
  onChange: HandleChange;
};

export enum ValueRange {
  from = 'valueFrom',
  to = 'valueTo',
}
